<template>
    <li
        class="ProgressiveCircle"
        :class="[{'is-active' : index === activeSlide}, classes]"
        :data-slide="index"
        @click="$emit('setActive', index)"
    >
        <span class="ProgressiveCircle__dot" />
    </li>
</template>

<script>
export default {
    name: 'ProgressiveCircle',

    props: {
        index: {
            type: Number,
            default: null
        },
        activeSlide: {
            type: Number,
            default: 0
        },
        classes: {
            type: String,
            default: ''
        },
    }
}
</script>

<style lang="scss" scoped>
    .ProgressiveCircle {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        position: relative;
        margin: 0 0.25rem;
        cursor: pointer;

        span {
            display: block;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: getColor('grey', 'medium');
            transition: all ease-in-out 0.345s;

            @include media-query(lap-and-up) {
                width: 8px;
                height: 8px;
            }
        }

        &.is-active {
            span {
                background: getColor('lightblue');
            }
        }
    }

    .ProgressiveCircle--white {
        &.is-active {
            span {
                background: #fff;
            }
        }
    }
</style>
